import React from 'react';
import DOMPurify from 'dompurify';
import { makeStyles } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles({
  root: {
    top: 0,
    position: 'relative'
  }, 
  marquesinaAviso: {
    borderRadius: '0px',
    '& .MuiAlert-root':{
      marginBottom: "15px",
    },  
    '& .MuiAlert-standardWarning': {
      backgroundColor: '#ffe7ca !important',
      color: '#aa4813',
      borderLeft: '5px solid #aa4813',
      borderRadius: '0px',
      fontSize: '14px',
      fontFamily: 'Catalana-Bold',
      padding: '2px 16px',
      '& .MuiAlert-icon': {
        color: '#aa4813',
      }, 
    },
    '& .MuiAlert-standardError': {
      backgroundColor: '#f1d4d4 !important',
      color: '#b91e1e',
      borderLeft: '5px solid #b91e1e',
      borderRadius: '0px',
      fontSize: '14px',
      fontFamily: 'Catalana-Bold',
      padding: '2px 16px',
      '& .MuiAlert-icon': {
        color: '#b91e1e',
      }, 
    },
    '& .MuiAlert-standardInfo': {
      backgroundColor: '#e0dfce !important',
      color: '#5b5c43',
      borderLeft: '5px solid #5b5c43',
      borderRadius: '0px',
      fontSize: '14px',
      fontFamily: 'Catalana-Bold',
      padding: '2px 16px',
      '& .MuiAlert-icon': {
        color: '#5b5c43',
      }, 
    },
    '& .MuiAlert-standardSuccess': {
      backgroundColor: '#e6efd8 !important',
      color: '#088600',
      borderLeft: '5px solid #088600',
      borderRadius: '0px',
      fontSize: '14px',
      fontFamily: 'Catalana-Bold',
      padding: '2px 16px',
      '& .MuiAlert-icon': {
        color: '#088600',
      }, 
    },
  },
  aviso: {
    margin: '1rem 0 0 0',
    color: '#aa4813',
    backgroundColor: '#ffe7ca',
    borderRadius: '0px',
    fontSize: '14px',
    borderLeft: '5px solid #aa4813',
    paddingLeft: '10px',
    fontFamily: 'Catalana-sans',
    fontWeight: 800,
    '& .MuiAlert-icon': {
        display: 'none',
    },
    '& .MuiAlert-message': {
        padding: '0px',
        display: 'flex',
        alignItems: 'center',
    }, 
    '& i': {
        marginRight: '5px',
        fontSize: '28px'
    },
    '& a':{
      textDecoration: 'none',
      cursor: 'pointer',
      borderBottom: '1px solid',
      paddingBottom: 0,
      color: '#aa4813',
    }
},

});

interface MarquesinaAlertProps {
  texto: string;
  disposable: boolean,
  onClose?: () => void;
}

export const MarquesinaAlert = ({texto, disposable, onClose}: MarquesinaAlertProps) => {

  const [abierto, setAbierto] = React.useState(true);
  const clases = useStyles();

  // @ts-ignore
  const manejarCerrar = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setAbierto(false);
    onClose && onClose();
  };

  // Sanitiza el contenido HTML
  const sanitizedTexto = DOMPurify.sanitize(texto);

  return (
    <Snackbar
      open={abierto}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      className={`${!disposable && clases.root }` }
    >
      {disposable ?
        <Alert className={clases.aviso} onClose={manejarCerrar}>
              <i className='icon-aviso-fixed-2'></i>
                <span dangerouslySetInnerHTML={{ __html: sanitizedTexto }}></span>
          </Alert> :
        <Alert className={clases.aviso} >
              <i className='icon-aviso-fixed-2'></i>
              <span dangerouslySetInnerHTML={{ __html: sanitizedTexto }}></span>
          </Alert>
      }
    </Snackbar>
  );
};
